export enum ValueUnit {
  Number = 'number',
  Percentage = 'percent',
  PercentagePoint = 'percent-point',
  Time = 'time',
  Duration = 'duration',
}
